import ApplicationController from './application_controller'

// Registration desk search/filter/raffle toolbar. Full-page navigation (not fetch) on every
// filter change, matching the pre-migration jQuery behavior -- see docs/givsum3_08_july.md Section 5.
export default class extends ApplicationController {
  static targets = ['search', 'clearButton', 'filter']

  connect() {
    this.toggleClear()
  }

  toggleClear() {
    if (!this.hasSearchTarget || !this.hasClearButtonTarget) return
    // '' clears the inline style so the .btn class's own display: inline-flex wins;
    // the SCSS default (display: none) covers the hidden state -- no FOUC on load.
    this.clearButtonTarget.style.display = this.searchTarget.value.length > 0 ? '' : 'none'
  }

  clearSearch(event) {
    event.preventDefault()
    window.location.href = window.location.pathname
  }

  applyFilters(event) {
    if (event.type === 'keydown' && event.key !== 'Enter') return
    event.preventDefault()

    const [ticketType, state] = this.filterTargets.map((select) => select.value)
    const params = new URLSearchParams({
      q: this.hasSearchTarget ? this.searchTarget.value : '',
      tt: ticketType || '',
      s: state || '',
    })

    this.showLoader()
    window.location.href = `${window.location.pathname}?${params.toString()}`
  }

  toggleRaffle(event) {
    event.preventDefault()
    const url = new URL(window.location.href)
    url.searchParams.has('raffle') ? url.searchParams.delete('raffle') : url.searchParams.set('raffle', 'true')
    window.location.href = url.toString()
  }

  // Bound on each ticket card's check-in circle (remote: true already fires the AJAX POST;
  // this just reflects the new state the same way the legacy page did -- full reload).
  reloadAfterCheckin(event) {
    event.preventDefault()
    window.location.reload()
  }

  showLoader() {
    const overlay = this.element.querySelector('.loader-overlay')
    if (overlay) overlay.style.display = 'flex'
  }
}
